import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ShopByMobileFiltersBar = ({ className, children, variant }) => (
  <div
    className={classNames(
      `lg:hidden px-5 py-3 md:px-[3.333vw] flex ${className}`,
      {
        'max-md:!py-3 max-md:!px-[3.333vw]': variant === 'collections-page',
      }
    )}
  >
    {children}
  </div>
);

ShopByMobileFiltersBar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['collections-page']),
};

export default ShopByMobileFiltersBar;
